export default {

	// 获取企业ticket
	getJsapiTicket:function(uri, companyId, _this) {
		// var ua = window.navigator.userAgent.toLowerCase();
		// if( (ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork') ){
		if (companyId == undefined || companyId == '' || companyId == null) {
			return;
		}
		
		var data = {
			companyId: companyId,
			cUri: uri,
		}
		_this.$http.getJsapiTicket(data, (res) => {
			var param = res.data;
			wx.agentConfig({
				corpid: param.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
				agentid: param.agentid, // 必填，企业微信的应用id （e.g. 1000247）
				timestamp: param.timestamp, // 必填，生成签名的时间戳
				nonceStr: param.noncestr, // 必填，生成签名的随机串
				signature: param.agentSignature, // 必填，签名，见附录-JS-SDK使用权限签名算法
				jsApiList: ['openUserProfile'], //必填，传入需要使用的接口名称
				success: function(res1) {
					// 回调
				},
				fail: function(res1) {
					if (res1.errMsg.indexOf('function not exist') > -1) {
						alert('版本过低请升级')
					}
				}
			});
		}, (errRes) => {

		})
		// }
	},

	// 配置企业微信
	qyvxConfig:function(param) {
		wx.config({
			beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
			debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
			appId: param.corpid, // 必填，企业微信的corpID
			timestamp: param.timestamp, // 必填，生成签名的时间戳
			nonceStr: param.noncestr, // 必填，生成签名的随机串
			signature: param.companySignature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
			jsApiList: ['openUserProfile'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
			success: function() {
				agentConfig(param);
			},
			fail: function(res) {

			}
		});
		wx.ready(function() {
			agentConfig(param);
		});
		wx.error(function(res) {
		});

	},

	agentConfig:function(param) {
		wx.agentConfig({
			corpid: param.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
			agentid: param.agentid, // 必填，企业微信的应用id （e.g. 1000247）
			timestamp: param.timestamp, // 必填，生成签名的时间戳
			nonceStr: param.noncestr, // 必填，生成签名的随机串
			signature: param.agentSignature, // 必填，签名，见附录-JS-SDK使用权限签名算法
			jsApiList: ['openUserProfile'], //必填，传入需要使用的接口名称
			success: function(res1) {
				// 回调
			},
			fail: function(res1) {
				if (res1.errMsg.indexOf('function not exist') > -1) {
					alert('版本过低请升级')
				}
			}
		});
	},

}
